document.addEventListener('DOMContentLoaded', () => {
  const resultContainer = document.querySelector('[data-predictive-search-result="header"]');
  if (!resultContainer) return;

  const imageCache = {};

  const getCollectionImageSrc = (collectionJson) => {
    if (!collectionJson) return null;
    const img = collectionJson.image || collectionJson.featured_image;
    if (!img) return null;
    if (typeof img === 'string') return img;
    return img.src || img.url || null;
  };

  const enhanceLinkWithImage = (linkEl, imgSrc) => {
    const title = linkEl.textContent.trim();
    if (!imgSrc || !title) return;

    linkEl.innerHTML = `
      <img src="${imgSrc}" alt="${title}" class="xo-predictive-search__item-image">
      <span class="xo-predictive-search__collection-title">${title}</span>
    `;
    linkEl.setAttribute('data-collection-enhanced', 'true');
  };

  const processCollections = () => {
    const collectionLists = resultContainer.querySelectorAll('.xo-predictive-search__item-list--article');
    collectionLists.forEach((list) => {
      const links = list.querySelectorAll('a.xo-predictive-search__item[data-search-result]');

      links.forEach((link) => {
        if (link.getAttribute('data-collection-enhanced') === 'true') return;

        try {
          const url = new URL(link.href, window.location.origin);
          const path = url.pathname.replace(/\/$/, '');

          if (!path.startsWith('/collections/')) return;

          if (Object.prototype.hasOwnProperty.call(imageCache, path)) {
            const cached = imageCache[path];
            if (cached) enhanceLinkWithImage(link, cached);
            return;
          }

          fetch(`${path}.json`)
            .then((res) => (res.ok ? res.json() : null))
            .then((data) => {
              if (!data || !data.collection) {
                imageCache[path] = null;
                return;
              }
              const src = getCollectionImageSrc(data.collection);
              imageCache[path] = src || null;
              if (src) enhanceLinkWithImage(link, src);
            })
            .catch(() => {
              imageCache[path] = null;
            });
        } catch {
          // Ignore malformed URLs
        }
      });
    });
  };

  const observer = new MutationObserver(() => {
    processCollections();
  });

  observer.observe(resultContainer, { childList: true, subtree: true });

  processCollections();
});

